module.exports = __webpack_public_path__ + "tables/media/Flaticon.0c6755dd.svg";